module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'tx.txs'
      }
    }
  }, [_vm._v("Tx count")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lol-window-chart"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6110d633","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tx.vue
// module id = 548
// module chunks = 1